module.exports = __webpack_public_path__ + "media/home/hero-ef59b34c.jpg";